import { Controller } from '@hotwired/stimulus'

// Barra fixa da página de vendas: aparece depois que o primeiro botão sai
// da tela por cima, some quando qualquer botão da página está visível ou
// quando uma resposta do FAQ aberta está na tela.
export default class extends Controller {
  static targets = ['cta', 'barra', 'link', 'faq']

  connect() {
    this.visiveis = new Set()
    this.passouDobra = false
    if (!('IntersectionObserver' in window)) return
    this.io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) this.visiveis.add(e.target)
        else this.visiveis.delete(e.target)
        if (e.target === this.ctaTargets[0]) this.passouDobra = !e.isIntersecting && e.boundingClientRect.top < 0
      })
      this.atualiza()
    })
    this.ctaTargets.forEach((c) => this.io.observe(c))
    this.onScroll = () => this.atualiza()
    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  disconnect() {
    this.io?.disconnect()
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll)
  }

  atualiza() {
    const faqAberto = this.faqTargets.some((d) => {
      if (!d.open) return false
      const r = d.getBoundingClientRect()
      return r.bottom > 0 && r.top < window.innerHeight
    })
    const on = this.passouDobra && this.visiveis.size === 0 && !faqAberto
    this.barraTarget.classList.toggle('on', on)
    this.barraTarget.setAttribute('aria-hidden', on ? 'false' : 'true')
    if (this.hasLinkTarget) this.linkTarget.tabIndex = on ? 0 : -1
  }
}
